import { render, staticRenderFns } from "./AlertPainel.vue?vue&type=template&id=63e0ae99&scoped=true&"
import script from "./AlertPainel.vue?vue&type=script&lang=ts&"
export * from "./AlertPainel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e0ae99",
  null
  
)

export default component.exports